import request from "@helpers/request";
import qs from "qs";

function fetchRegions(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/pm/regions`, qs.stringify(data), { ...config });
}
function fetchETL(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/etl`, data, { ...config });
}
function fetchETLR(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/etlR`, data, { ...config });
}
function brtel_mci_nodeList(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/brtel_mci/nodeList`, data, { ...config });
}
function brtel_mci_kpi_list(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/brtel_mci/kpiList`, data, { ...config });
}
function brtel_mci_kpi_query(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/brtel_mci/query`, data, { ...config });
}
function fetchProvinces(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/pm/provinces`, qs.stringify(data), { ...config });
}

function fetchCities(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/pm/cities`, qs.stringify(data), { ...config });
}

function fetchSites(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/pm/sites`, qs.stringify(data), { ...config });
}

function fetchKpi(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/kpi2`, data, { ...config });
}
function fetchKpiR(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/kpi2R`, data, { ...config });
}
//kpi2RbyName
function fetchKpi2RbyName(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/kpi2RbyName`, data, { ...config });
}
function fetchkpi2RDownload(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/kpi2RDownload`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
      responseType: "blob"
    });

}
function fetchkpi2RExport(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/kpi2RExport`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
      responseType: "blob"
    });

}
function fetchKpi2(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/kpi`, data, { ...config });
}
function fetchRNC(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/pm/rnc`, {}, { ...config });
}
function RightelWPC4G(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/wpc/4g`, data, { ...config });
}
function RightelPSshare(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/ps_share`, data, { ...config });
}
function Rightel_ps_cs_daily(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/ps_cs_daily`, data, { ...config });
}
function RightelCarrierShare(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/carrier_share`, data, { ...config });
}
function importData(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`/v1/pm/import`, params, { ...config });
}
function importReports(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`/v1/pm/rightel/ReportRepo/upload`, params, { ...config });
}
function reportsList(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/ReportRepo/list`, params, { ...config });
}
function reportsDelete(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/ReportRepo/delete`, params, { ...config });
}
function reportsDownload(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/ReportRepo/download`, params, {
      ...config,
      timeout: 15 * 60 * 1000,
      responseType: "blob",
    });
}
function downloadKML(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/kml`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
      responseType: "blob",
    });
}

function fetchP1P2(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/P1P2`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
    });
}

function fetchP1P22(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/P1P22`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
    });
}

function fetchP1P2Dynamic(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/P1P2_dynamic`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
    });
}
function rightel_frame_loss(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/frame_loss`, data, { ...config });
}
function rightel_rtwp(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/rtwp`, data, { ...config });
}
function rightel_pucch(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/pucch`, data, { ...config });
}
function rightel_sleeping_cell_LTE(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/sleeping_cell_LTE`, data, { ...config });
}
function rightel_sleeping_cell_UMTS(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/sleeping_cell_UMTS`, data, { ...config });
}
function rightel_dashboard_list(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/dashboard/list`, data, { ...config });
}
function rightel_dashboard_section_list(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/dashboard/section/list`, data, { ...config });
}
function rightel_dashboard_change_Access(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/dashboard/access`, data, { ...config });
}
//rightel_dashboard_change_Access
function rightel_dashboard_addSection(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/dashboard/addSection`, data, { ...config });
}
function rightel_dashboard_removeSection(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/dashboard/removeSection`, data, { ...config });
}
function rightel_dashboard_delete(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/pm/rightel/dashboard/delete`, data, { ...config });
}
const baseUrl = "/v1/pm";
function Post(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function PostForm(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function Get(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config });
}
function PostBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
function GetBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
const performanceManagementService = {
  Get,
  Post,
  PostBlob,
  PostForm,
  GetBlob,
  rightel_dashboard_list,
  rightel_dashboard_change_Access,
  rightel_dashboard_section_list,
  rightel_dashboard_addSection,
  rightel_dashboard_removeSection,
  rightel_dashboard_delete,
  rightel_frame_loss,
  rightel_rtwp,
  rightel_pucch,
  rightel_sleeping_cell_LTE,
  rightel_sleeping_cell_UMTS,
  brtel_mci_nodeList,
  brtel_mci_kpi_list,
  brtel_mci_kpi_query,
  fetchRegions,
  fetchProvinces,
  fetchCities,
  fetchSites,
  fetchRNC,
  fetchKpi,
  fetchKpiR,
  importData,
  downloadKML,
  fetchP1P2,
  fetchP1P22,
  fetchP1P2Dynamic,
  fetchETL,
  fetchETLR,
  RightelWPC4G,
  RightelPSshare,
  fetchkpi2RExport,
  fetchKpi2RbyName,
  fetchkpi2RDownload,
  RightelCarrierShare,
  importReports,
  reportsList,
  reportsDelete,
  reportsDownload,
  Rightel_ps_cs_daily
};

export default performanceManagementService;
